import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './Components/Sass/main.scss'
import Home from './Components/Pages/Home';
import PrivacyPolicy from './Components/Pages/PrivacyPolicy'
import CelestaForte250 from './Components/Pages/CelestaForte250';
import CelestaForte500 from './Components/Pages/CelestaForte500';


function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products/celesta-forte-250" element={<CelestaForte250 />} />
          <Route path="/products/celesta-forte-500" element={<CelestaForte500 />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
